import React from 'react';
import PropTypes from 'prop-types';

const MiniModal = props => {
    return (
        <div
            data-testid="test-minimodal"
            className="minimodal shadow-sm"
            style={{
                display: props.show ? 'block' : 'none',
                height: props.height ?? 'auto',
                width: props.width ?? 'auto',
                top: props.posY ?? '0px',
                right: props.posX ?? '0px',
                bottom: props.posY === 'auto' ? '1rem' : 'auto'
            }}
        >
            <div
                data-testid="test-minimodal-title"
                className="minimodal__title"
            >
                {props.titleIcon}
                <h6>{props.title}</h6>
                <span
                    className="minimodal__title__close"
                    onClick={() => props.onHide()}
                >
                    &times;
                </span>
            </div>
            <div
                data-testid="test-minimodal-body"
                className={`minimodal__body ${props.bodyClassName}`}
            >
                {props.children}
            </div>
            <div
                data-testid="test-minimodal-footer"
                className="minimodal__footer"
            >
                {props.footer}
            </div>
        </div>
    );
};

MiniModal.propTypes = {
    footer: PropTypes.any,
    children: PropTypes.any,
    onHide: PropTypes.func,
    title: PropTypes.any,
    posX: PropTypes.string,
    posY: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    show: PropTypes.bool,
    titleIcon: PropTypes.any,
    bodyClassName: PropTypes.string
};

export default MiniModal;
